import type { Key } from 'react';

import { Chip } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { capitalizeTopic } from 'src/app/shared/utils/topic';

import { useTagsFilter } from './hooks/useTagsFilter';

export const TagsFilter: React.FC<{ filteredSectionId: Key }> = ({ filteredSectionId }) => {
	const {
		data: { displayed, resultsAreFiltered, tags },
		actions: { updateFilter, clearFilters },
	} = useTagsFilter();

	if (!displayed) return null;

	return (
		<div className="mb-3 overflow-auto pb-4 pl-1 pt-1">
			<div className="flex gap-2">
				<Chip
					data-qa="all-chip"
					as="button"
					className="shrink-0"
					onClick={() => clearFilters(filteredSectionId)}
					active={!resultsAreFiltered}
				>
					<Translate value="corgi.local.petition_section.all_filter" />
				</Chip>

				{tags.map((tag) => (
					<Chip
						as="button"
						data-qa={`${tag.name}-chip`}
						className="shrink-0"
						key={tag.id}
						onClick={() => updateFilter(tag.id, filteredSectionId)}
						active={tag.selected}
					>
						{capitalizeTopic(tag.name)}
					</Chip>
				))}
			</div>
		</div>
	);
};
